import { Module } from "vuex";
import { RootState } from "../types";
import { Reimbursement } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  refresh: false,
};

export const reimbursements: Module<Reimbursement, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
